import { BALLOT_DOCUMENT_TYPE, BALLOT_RENEWAL_DOCUMENT_TYPE, CERTIDAO_DIRETIVA_EUROPA_DOCUMENT_TYPE, CERTIDAO_DIRETIVA_SUICA_DOCUMENT_TYPE, CERTIDAO_DIRETIVA_UK_DOCUMENT_TYPE, CERTIDAO_DIVIDA_DOCUMENT_TYPE, CERTIDAO_SITUACAO_REGULAR_DOCUMENT_TYPE, CERTIDAO_SUBMISSAO_DOCUMENT_TYPE, CERTIFICADO_PARTICIPACAO_DOCUMENT_TYPE, GOOD_STANDING_DOCUMENT_TYPE, NOTIFICACAO_DIVIDA_DOCUMENT_TYPE, TITULARIDADE_SEGURO_DOCUMENT_TYPE } from "../../common/constants";
import { formatActionLogFormValues } from "../../common/formatters/action-log";
import { formatAssociateDataFormValues } from "../../common/formatters/associate";
import { GET_ASSOCIATE_DATA_SUCCESS, DOWNLOAD_PROFILE_PICTURE_SUCCESS, GET_ACTION_LOG_SUCCESS, SET_EDIT_MODE, CHANGE_APP_LANGUAGE } from "../action-types/profile";

const initialState = {
    associate: null,
    profilePicture: null,
    registrationDocs: [],
    processDocs: [],
    actionLog: [],
    rawActionLog: [],
    ballot: null,
    editMode: false,
    language: "pt"
};

const profileReducer = (state = initialState, action) => {
    switch(action.type) {
        case GET_ASSOCIATE_DATA_SUCCESS:

            let processDocs = [];

            if(action.associate.registrationDocs !== undefined && action.associate.registrationDocs !== null) {
                for (let i = 0; i < action.associate.registrationDocs.length; i++) {
                    if(action.associate.registrationDocs[i].documentTypeId === BALLOT_DOCUMENT_TYPE ||
                       action.associate.registrationDocs[i].documentTypeId === BALLOT_RENEWAL_DOCUMENT_TYPE ||
                       action.associate.registrationDocs[i].documentTypeId === CERTIFICADO_PARTICIPACAO_DOCUMENT_TYPE ||
                       action.associate.registrationDocs[i].documentTypeId === CERTIDAO_SITUACAO_REGULAR_DOCUMENT_TYPE ||
                       action.associate.registrationDocs[i].documentTypeId === TITULARIDADE_SEGURO_DOCUMENT_TYPE ||
                       action.associate.registrationDocs[i].documentTypeId === CERTIDAO_SUBMISSAO_DOCUMENT_TYPE ||
                       action.associate.registrationDocs[i].documentTypeId === GOOD_STANDING_DOCUMENT_TYPE ||
                       action.associate.registrationDocs[i].documentTypeId === CERTIDAO_DIRETIVA_SUICA_DOCUMENT_TYPE ||
                       action.associate.registrationDocs[i].documentTypeId === CERTIDAO_DIRETIVA_UK_DOCUMENT_TYPE ||
                       action.associate.registrationDocs[i].documentTypeId === CERTIDAO_DIRETIVA_EUROPA_DOCUMENT_TYPE ||
                       action.associate.registrationDocs[i].documentTypeId === NOTIFICACAO_DIVIDA_DOCUMENT_TYPE ||
                       action.associate.registrationDocs[i].documentTypeId === CERTIDAO_DIVIDA_DOCUMENT_TYPE) {
                        processDocs.push({ name: action.associate.registrationDocs[i].name, documentRef: action.associate.registrationDocs[i].nodeRef });
                    }
                }
            }

            console.log(action.associate.associate);
            
            if(action.associate.associate.personalData !== undefined && action.associate.associate.personalData !== null) {
                return {
                    ...state,
                    associate: formatAssociateDataFormValues(action.associate.associate),
                    ballot: action.associate.ballot,
                    registrationDocs: action.associate.registrationDocs,
                    processDocs: processDocs
                };
            }
            else {
                return {
                    ...state,
                    associate: {
                        associateId: action.associate.associate.associateId,
                        personalData: {
                            name: action.associate.associate.internalData.name,
                            nif: action.associate.associate.internalData.nif,
                            niss: action.associate.associate.internalData.niss,
                            iban: action.associate.associate.internalData.iban,
                            streetTypePlaceholder: action.associate.associate.internalData.streetTypePlaceholder,
                            addressLine: action.associate.associate.internalData.addressLine,
                            doorNumber: action.associate.associate.internalData.doorNumber,
                            doorFloor: action.associate.associate.internalData.doorFloor,
                            cP4: action.associate.associate.internalData.cP4,
                            cP3: action.associate.associate.internalData.cP3,
                            city: action.associate.associate.internalData.city
                        }
                    },
                    ballot: null,
                    registrationDocs: [],
                    processDocs: processDocs
                };
            }
        case DOWNLOAD_PROFILE_PICTURE_SUCCESS:
            return {
                ...state,
                profilePicture: action.profilePicture.fileContent
            };
        case GET_ACTION_LOG_SUCCESS:
            return {
                ...state,
                actionLog: formatActionLogFormValues(action.actionLog),
                rawActionLog: action.actionLog
            };
        case SET_EDIT_MODE:
            return {
                ...state,
                editMode: action.editMode
            };
        case CHANGE_APP_LANGUAGE:
            return {
                ...state,
                language: action.language
            };
        default:
            return state;
    }
}

export default profileReducer;